"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
require("@syncfusion/ej2/tailwind.css");
require("@syncfusion/ej2-react-querybuilder/styles/tailwind.css");
var ej2_react_pivotview_1 = require("@syncfusion/ej2-react-pivotview");
var flattenJSON = function (obj, res, extraKey) {
    if (obj === void 0) { obj = {}; }
    if (res === void 0) { res = {}; }
    if (extraKey === void 0) { extraKey = ''; }
    for (var key in obj) {
        // @ts-ignore
        if (typeof obj[key] !== 'object') {
            // @ts-ignore
            res[extraKey + key] = obj[key];
        }
        else {
            // @ts-ignore
            flattenJSON(obj[key], res, "".concat(extraKey).concat(key, "."));
        }
        ;
    }
    ;
    return res;
};
var Dashboard = /** @class */ (function (_super) {
    __extends(Dashboard, _super);
    function Dashboard(props) {
        var _this = _super.call(this, props) || this;
        _this.pivotObjCustomer = null;
        _this.pivotObjPromo = null;
        _this.pivotObjSent = null;
        // let data: any = [];
        var data = props.pointsData.map(function (item) {
            return flattenJSON(item);
        });
        // console.log(data);
        _this.dataSourceSettings = {
            columns: [],
            dataSource: data,
            expandAll: false,
            filters: [],
            formatSettings: [{ name: 'points', useGrouping: true, format: 'N' }],
            rows: [{ name: 'name' }, { name: 'title' }],
            values: [{ name: 'points', caption: 'Points' }, { name: 'title', caption: 'Promo' }],
        };
        _this.dataSourceSettingsPromo = {
            columns: [],
            dataSource: data,
            expandAll: false,
            filters: [],
            formatSettings: [{ name: 'points', useGrouping: true, format: 'N' }],
            rows: [{ name: 'title' }, { name: 'name' }],
            values: [{ name: 'points', caption: 'Points' }, { name: 'title', caption: 'Promo' }],
        };
        _this.dataSourceSettingsSent = {
            columns: [],
            dataSource: data,
            expandAll: false,
            filters: [],
            formatSettings: [{ name: 'points', useGrouping: true, format: 'N' }],
            rows: [{ name: 'sent_at' }, { name: 'name' }],
            values: [{ name: 'points', caption: 'Points' }, { name: 'title', caption: 'Promo' }],
            sortSettings: [{ name: 'sent_at', order: 'Descending' }]
        };
        _this.toolbarOptions = ['FieldList'];
        return _this;
    }
    Dashboard.prototype.render = function () {
        var _this = this;
        var toolbarOptions = ['Chart'];
        function columnRenderCustomer(args) {
            args.stackedColumns[0].textAlign = "Left";
        }
        function btnClick() {
            // @ts-ignore
            this.pivotObjCustomer.excelExport();
        }
        return (react_1.default.createElement(AppLayout_1.default, { title: 'Dashboard', renderHeader: function () { return (react_1.default.createElement("h2", { className: 'font-semibold text-xl text-gray-800 leading-tight' }, "Dashboard")); } },
            react_1.default.createElement("div", { className: 'py-12' },
                react_1.default.createElement("div", { className: 'mx-auto sm:ps-6 lg:px-8' },
                    react_1.default.createElement("div", { className: 'bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4' },
                        react_1.default.createElement("div", { className: 'flex mb-4' },
                            react_1.default.createElement("div", { className: 'flex-1 m-1' },
                                react_1.default.createElement("header", null, "Points Per Customer"),
                                react_1.default.createElement(ej2_react_pivotview_1.PivotViewComponent, { ref: function (d) { return _this.pivotObjCustomer = d; }, id: 'PivotView', height: 350, width: '100%', allowCalculatedField: true, dataSourceSettings: this.dataSourceSettings, gridSettings: {
                                        columnWidth: 400,
                                        allowTextWrap: true,
                                    }, allowExcelExport: true, allowPdfExport: true, showToolbar: true, toolbar: ['Export'] },
                                    react_1.default.createElement(ej2_react_pivotview_1.Inject, { services: [ej2_react_pivotview_1.Toolbar, ej2_react_pivotview_1.ExcelExport, ej2_react_pivotview_1.PDFExport] }))),
                            react_1.default.createElement("div", { className: 'flex-1 m-1' },
                                react_1.default.createElement("header", null, "Points Sent on Date"),
                                react_1.default.createElement(ej2_react_pivotview_1.PivotViewComponent, { ref: function (d) { return _this.pivotObjSent = d; }, id: 'PivotViewSent', height: 350, allowCalculatedField: true, dataSourceSettings: this.dataSourceSettingsSent, displayOption: { view: 'Table' }, gridSettings: {
                                        columnWidth: 220,
                                        allowTextWrap: true,
                                    } }))),
                        react_1.default.createElement("div", { className: 'flex mt-4' },
                            react_1.default.createElement("div", { className: 'flex-1' },
                                react_1.default.createElement("header", null, "Points Per Promo"),
                                react_1.default.createElement(ej2_react_pivotview_1.PivotViewComponent, { ref: function (d) { return _this.pivotObjPromo = d; }, id: 'PivotViewPromo', height: 350, allowCalculatedField: true, dataSourceSettings: this.dataSourceSettingsPromo, displayOption: { view: 'Table' }, gridSettings: {
                                        columnWidth: 220,
                                        allowTextWrap: true,
                                    } }))))))));
    };
    return Dashboard;
}(react_1.default.PureComponent));
exports.default = Dashboard;
